const IconX = (): JSX.Element => {
  return (
    <>
      <path d="M13.97,10.16L22.71,0h-2.07l-7.59,8.82L6.99,0H0l9.17,13.34L0,24h2.07l8.02-9.32,6.4,9.32h6.99l-9.51-13.84h0ZM11.13,13.46l-.93-1.33L2.82,1.56h3.18l5.97,8.53.93,1.33,7.75,11.09h-3.18l-6.32-9.06h0Z" />
    </>
  );
};

export default IconX;
